import React, { useContext, useState } from "react";
import { Alert, Nav, NavItem, NavLink } from "reactstrap";
import { AppContext } from "../../context";
import StoreOpsBatchesSection from "./StoreOpsBatchesSection";
import StoreOpsPartsSection from "./StoreOpsPartsSection";
import StoreOpsShipmentsSection from "./StoreOpsShipmentsSection";
import "./StoreSalesDashboard.css";

const StoreOpsProduction = () => {
  const { currentUser } = useContext(AppContext);
  const [activeTab, setActiveTab] = useState("parts");

  if (!currentUser?.admin) {
    if (currentUser) {
      return (
        <div className="min-vh-100 w-100 mw-100 bg-light">
          <div className="container-fluid py-4 px-3 px-lg-4 w-100 mw-100">
            <Alert color="danger" fade={false}>
              UNAUTHORIZED
            </Alert>
          </div>
        </div>
      );
    }

    return null;
  }

  return (
    <div className="min-vh-100 w-100 mw-100 bg-light">
      <div className="container-fluid py-4 px-3 px-lg-4 w-100 mw-100">
        <h1 className="h4 fw-bold mb-4">Ops Production</h1>

        <div className="store-dashboard-tabbed">
          <Nav tabs className="store-dashboard-nav-tabs mb-0 w-100">
            <NavItem>
              <NavLink
                href="#"
                className="fw-bold"
                active={activeTab === "parts"}
                onClick={(event) => {
                  event.preventDefault();
                  setActiveTab("parts");
                }}
              >
                Parts
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                href="#"
                className="fw-bold"
                active={activeTab === "batches"}
                onClick={(event) => {
                  event.preventDefault();
                  setActiveTab("batches");
                }}
              >
                Batches
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                href="#"
                className="fw-bold"
                active={activeTab === "shipments"}
                onClick={(event) => {
                  event.preventDefault();
                  setActiveTab("shipments");
                }}
              >
                Shipments
              </NavLink>
            </NavItem>
          </Nav>

          <div className="store-dashboard-tab-panel">
            {activeTab === "parts" && <StoreOpsPartsSection />}
            {activeTab === "shipments" && <StoreOpsShipmentsSection />}
            {activeTab === "batches" && <StoreOpsBatchesSection />}
          </div>
        </div>
      </div>
    </div>
  );
};

export default StoreOpsProduction;
